import {TrackableEntity} from './data/ChangeTrackable';

export class PimsCntrEvent extends TrackableEntity {
    pimsCntrId: number = 0;
    cntrNo: string = '';
    pickupNo: string = '';
    name: string = '';
    datetime: string | null = null;
    date: string|null = null;
    time: string|null = null;
    locName: string = '';
    lastDate: string | null = null;
    check: boolean = false;
    seq: number = 0;
    isVisible: boolean = false;

    constructor(init?:Partial<PimsCntrEvent>) {
        super();
        this.key=undefined;
        Object.assign(this, init);
        this.noTrackProps.push('pimsCntrId', 'cntrNo', 'pickupNo', 'name', 'lastDate', 'check', 'seq', 'isVisible',
        'date', 'time');
    }

    // get date() { 
    //     return formatDate(this.datetime);
    // }
    // set date(val:string|null) { 
    //     // Replace before T to value
    //     if(!val) return;
    //     const result = dateTextToIso(val);
    //     if(result.valid) this.datetime = result.iso;
    // }

    // get time() { 
    //     return getTime(this.datetime); 
    // }
    // set time(val:string|null) {
    //     // HH:mm
    //     if(!val) return;
    //     // Replace time part of datetime
    //     const tindex = this.datetime?.indexOf('T')??-1;
    //     if(tindex < 0) return;
    //     this.datetime = this.datetime?.substring(0, tindex + 1) + val + ':00';
    // }
}
